import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PrivateClassTile } from '../../../live-class-section/class-tile/private-class-tile';
import { LiveClassLessonTrack } from '../../live-class-lesson-track-dto';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-left-header-banner',
  templateUrl: './private-class-left-header-banner.component.html',
  styleUrls: ['./private-class-left-header-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassLeftHeaderBannerComponent {
  @Input() track: LiveClassLessonTrack;
  @Input() liveClassTile: PrivateClassTile;
  @Input() lessons: Array<PrivateClassLesson>;
  @Input() reducedBannerWidth = false;

  public get privateClassesLocked(): boolean {
    return this.liveClassTile.liveClass.liveClassStatus === 'COMPLETE';
  }

  public get disableAllCollectionsLink(): boolean {
    if (!this.liveClassTile) {
      return false;
    }
    return this.liveClassTile.currentState === 'HAS_JOIN' || this.liveClassTile.currentState === 'HAS_REJOIN';
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-left-header-banner/private-class-left-header-banner.component.ts